"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var checkInput_1 = require("./checkInput");
exports.hexToRgb = checkInput_1.hexToRgb;
//# sourceMappingURL=index.js.map